import React from "react"

const AvalithTime = () => {
  return (
    <section className="bg-neutral py-12">
      <div className="container mx-auto px-6">
        <div className="w-full md:w-2/3 lg:w-1/2 text-center mx-auto">
          <h3 className="text-7xl font-light pb-8 leading-tight">
            <span className="text-secondary font-bold block">Avalith</span> time
          </h3>
          <p className="pb-8">          
            This is the moment when we <b>disconnect</b> from our daily activities, in order to <b>connect</b> with the things we are passionate about, with the aim of finding the balance between work and personal life.
          </p>
          <p className="pb-8 italic font-medium flex flex-wrap justify-center">
            <span className="mx-2">#Enjoy</span>
            <span className="mx-2">#Family</span>
            <span className="mx-2">#Friends</span>
            <span className="mx-2">#Harmony</span>
            <span className="mx-2">#GiftDay</span>
            <span className="mx-2">#EntertainmentDay</span>
            <span className="mx-2">#BirthdayOff</span>
            <span className="mx-2">#TimeOff</span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default AvalithTime
